<template>
  <div class='content'></div>
</template>



<script>
export default {
  name: 'home',
  components: {},
  data() {
    return {}
  },
  created() { 
    
  },
  beforeCreate() {
    this.$router.push({
      path: '/download',
      query:{}
    })
  },
  methods: {}
}
</script>



<style >
</style>